import { defineMessages } from "react-intl"

export const pricingFieldMessages = defineMessages({
	accessories: {
		defaultMessage: "Accessories",
		id: "listing.accessories",
	},
	automobileTaxLabel: {
		defaultMessage: "Automobile Tax",
		id: "listing.automobileTax.label",
	},
	customerPriceLabel: {
		defaultMessage: "Customer price (gross)",
		id: "listing.customerPrice.label",
	},
	editPriceDisabledForNewCanadianVehicles: {
		defaultMessage: "Please use vehicle price field for new vehicles.",
		id: "listing.listingPrice.disabled.newCanadian",
	},
	editPriceDisabledForUSPVMSVehicles: {
		defaultMessage: "Please use PVMS to edit the listing price.",
		id: "listing.listingPrice.disabled.pvms",
	},
	editPriceDisabledForUSVMSVehicles: {
		defaultMessage: "Please use {value} to edit the listing price.",
		id: "listing.listingPrice.disabled.vms",
	},
	hasSpareWheelHint: {
		defaultMessage: "Relevant for tire tax calculation",
		id: "listing.hasSpareWheel.hint",
	},
	hasSpareWheelLabel: {
		defaultMessage: "Does the vehicle have a spare tire?",
		id: "listing.hasSpareWheel.label",
	},
	inspectionRegistrationAgencyFeeLabel: {
		defaultMessage: "Inspection Registration Agency Fee",
		id: "listing.inspectionRegistrationAgencyFee.label",
	},
	inspectionRegistrationLabel: {
		defaultMessage: "Inspection Registration",
		id: "listing.inspectionRegistration.label",
	},
	liabilityInsuranceLabel: {
		defaultMessage: "Liability Insurance",
		id: "listing.liabilityInsurance.label",
	},
	lightVehicleTaxEnvironmentalPerformanceLevyLabel: {
		defaultMessage: "Light Vehicle Tax Environmental Performance Levy",
		id: "listing.lightVehicleTaxEnvironmentalPerformanceLevy.label",
	},
	minimumPriceLabel: {
		defaultMessage: "Minimum price (gross)",
		id: "listing.minimumPrice.label",
	},
	miscPriceLabel: {
		defaultMessage: "Miscellaneous costs",
		id: "listing.miscPrice.label",
	},
	netPriceLabel: {
		defaultMessage: "Price without taxes",
		id: "listing.netPrice.label",
	},
	notPossibleToEditVatDeductible: {
		defaultMessage: "Cannot be edited for selected vehicle type: {vehicleType}",
		id: "listing.vatDeductible.disabledForVehicleType",
	},
	parkingCertificateLabel: {
		defaultMessage: "Parking Certificate",
		id: "listing.parkingCertificate.label",
	},
	parkingCertificationAcquisitionAgencyFeeLabel: {
		defaultMessage: "Parking Certification Acquisition Agency Fee",
		id: "listing.parkingCertificationAcquisitionAgencyFee.label",
	},
	purchasePriceLabel: {
		defaultMessage: "Purchase price (gross)",
		id: "listing.purchasePrice.label",
	},
	recyclingFeeLabel: {
		defaultMessage: "Recycling Fee",
		id: "listing.recyclingFee.label",
	},
	showLuxuryTaxLabel: {
		defaultMessage: "Luxury Tax",
		id: "listing.showLuxuryTax.label",
	},
	showLuxuryTaxNo: {
		defaultMessage: "Exclude from Sales Price",
		id: "listing.showLuxuryTax.no",
	},
	showLuxuryTaxYes: {
		defaultMessage: "Include in price breakdown",
		id: "listing.showLuxuryTax.yes",
	},
	tonnageTaxLabel: {
		defaultMessage: "Tonnage Tax",
		id: "listing.tonnageTax.label",
	},
	vatDeductibleLabel: {
		defaultMessage: "VAT deductible",
		id: "listing.vatDeductible.label",
	},
	vehicleGrossPriceLabel: {
		defaultMessage: "Vehicle price (gross)",
		id: "listing.vehicleGrossPrice.label",
	},
	vehiclePriceLabel: {
		defaultMessage: "Vehicle price",
		id: "listing.vehiclePrice.label",
	},
})
